import initialState from 'flux/initialState/routerMatch.initialState';
import { routerMatch as actions } from 'flux/actions';

export default function (state = initialState, action) {
  const { types } = actions;

  switch (action.type) {
    case types.UPDATE_ROUTER_MATCH: {
      const { match } = action.payload;

      return {
        ...match,
      };
    }

    default:
      return state;
  }
}
